import { CommonModule  } from '@angular/common';
import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataFilterPipe } from './datafilter.pipe';
import { PickerComponent } from "./picker.component";
import { HelpDeskComponent } from "./helpdesk.component";
import { HelpDeskTicketsComponent } from "./helpdesktickets.component";
import { SiteInfoComponent } from "./siteinfo.component";
import { SiteInfoImageUploadComponent } from './siteinfoimageupload.component'
import { HelpDeskReplyComponent } from "./helpdeskreply.component";
import { TrakiiComponent } from './trakii.component';

//import { DateRangeComponent } from './daterange.component';
//import { DatePickerComponent } from "./datePicker.component";

@NgModule({
    imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule  ],
  declarations: [DataFilterPipe, PickerComponent, HelpDeskComponent, HelpDeskTicketsComponent, SiteInfoComponent, SiteInfoImageUploadComponent, HelpDeskReplyComponent, TrakiiComponent],
  exports: [DataFilterPipe, CommonModule, CommonModule, FormsModule, ReactiveFormsModule, PickerComponent, HelpDeskComponent, HelpDeskTicketsComponent, SiteInfoComponent, SiteInfoImageUploadComponent, HelpDeskReplyComponent, TrakiiComponent ]
})

export class SharedModule {
    
    up: string = "up";
    orderMe(event: Event, myData: any, myKey: any) {
        var direction = this.up
        if (direction == "up") { this.up = "down" }
        else { this.up = "up" }
        myData.sort((a: any, b: any) => {
            if (direction == "up") { if (a[myKey] < b[myKey]) { return 1; } else if (a[myKey] > b[myKey]) { return -1; } else { return 0; } }
            else { if (a[myKey] < b[myKey]) { return -1; } else if (a[myKey] > b[myKey]) { return 1; } else { return 0; } }
        });
        return myData;
  }




  encodeImageUrl(filename: string) {
    return encodeURIComponent(filename.trim())
  }

}
